const Conditional = ({ if: condition, children }) => {
  if (!condition) {
    return null;
  }

  return children;
};

export default Conditional;
